import React from 'react';

function Home() {
  return (
    <div className="home-content">
      <h2>Welcome to our page</h2>
      <p>
        Greetings and welcome to our Mathmagitian page. Here you will enjoy multiple
        parts of our app, like a fully functional calculator, daily quotes from your
        favorite mathemagicians, and so much more!!!!
      </p>
      <p>
        Please go right ahead and enjoy our app.
      </p>
    </div>
  );
}

export default Home;
